module.exports = __webpack_public_path__ + "static/img/logo_trans.14a83aed.png";